import apiClient from '@/axios';

export default {
    async getReviews(filters = {}) {
      const response = await apiClient.get('/admin/review', {
        params: filters, // Send filters as query parameters
      });
      return response.data.reviews;
    }
  };